import { createContext } from 'react'
import { AuthorizationUseCases } from '../useCase/authorization/authorization';
 
import { AudioUseCases } from '../useCase/audio/audio'; 
import { CampaignUseCases } from '../useCase/campaign/campaign'; 
import { DidUseCases } from '../useCase/did/did'; 
import { AudienceUseCases } from '../useCase/audience/audiense';
import { BlockedUseCases } from '../useCase/blocked/blocked';
import {SegmentUseCases} from "../useCase/segment/segment";
import {DictionaryUseCases} from "../useCase/dictionaries/dictionaries";

interface UseCasesContextInterface {
    authUseCase: AuthorizationUseCases;
    segmentsUseCase: SegmentUseCases;
    audienceUseCase: AudienceUseCases; 
    audioUseCase: AudioUseCases; 
    campaignUseCase: CampaignUseCases;
    dictionariesUseCase: DictionaryUseCases;
    didUseCase: DidUseCases; 
    blockedUseCase: BlockedUseCases;
}

export const UseCasesContext = createContext<UseCasesContextInterface | null>(null)